import HorizontalRule from '../HorizontalRule';
import ArrowDown from '../icons/ArrowDown';
import React, { Component, Fragment } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { languageContent } from '../../@helpers';
import './style.scss';

class PageHero extends Component {
  constructor() {
    super()
    this.state = {}
    this.contentAnchor = null
  }


  smoothScrollToAnchor = () => {
    window.scrollTo(0, document.getElementById('current_page_hero').scrollHeight)
  }

  render() {
    // console.log(`PAGE_HERO\n$::`, this.props);
    const { data } = this.props;
    const content = languageContent();
    const { component } = content;
    const { Buttons: { readMore } } = component.General;
    console.log(data);
    return (
      <Fragment>
        <header className={data.lxl_page_hero_custom_class + " page_hero"} id="current_page_hero" data-colorscheme={data.lxl_colorscheme}>
          <div className="content">
            <h1 className="title">
              {ReactHtmlParser(data.lxl_page_hero_title)}
              <HorizontalRule data={{ 'lxl_separator_variant': 'hero' }} />
            </h1>
            {data.lxl_page_hero_copy && <div className="copy">{ReactHtmlParser(data.lxl_page_hero_copy)}</div>}
          </div>
          <div className="button_group">
            <a href="#content" className="button read-more" onClick={() => this.smoothScrollToAnchor()}>
              <span>{readMore}&nbsp;</span>
              <ArrowDown />
            </a>
          </div>
          <div className="hero_image--container">
            {data.lxl_page_hero_background_image && <img className="hero_image" src={data.lxl_page_hero_background_image} alt="" role="presentation" />}
          </div>
        </header>
      </Fragment>
    )
  }
}

export default PageHero
